/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class BatchesController extends Controller {
  @service
  toaster;

  @sort('model.batches', (a, b) => b.createTime - a.createTime)
  sortedBatches;

  @tracked
  deletingBatch = null;
  @tracked
  deleteDialogOpen = false;
  @tracked
  deleteInProgress = false;

  @action
  openDeleteDialog(batch) {
    this.deletingBatch = batch;
    this.deleteDialogOpen = true;
  }

  @action
  closeDeleteDialog() {
    if (this.deleteInProgress) {
      return;
    }
    this.deletingBatch = null;
    this.deleteDialogOpen = false;
  }

  @action
  deleteBatch() {
    let batch = this.deletingBatch;
    if (!batch) {
      return;
    }

    this.deleteInProgress = true;
    batch
      .destroyRecord()
      .then(() => {
        this.toaster.success('Grade Import successfully deleted.');
        this.deletingBatch = null;
        this.deleteDialogOpen = false;
      })
      .catch(() => {
        // Keep the record so the user can retry; ember-data marks it as
        // errored but it remains in the list.
        this.toaster.error('Failed to delete the import. Please try again.');
      })
      .finally(() => {
        this.deleteInProgress = false;
      });
  }
}
